<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 class="fronttitle paired">Contents</h1>
<hr/>
<p class="toc sub"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></p>
<p class="toc sub"><a href="#/contents">Contents</a></p>
<p class="toc sub"><a href="#/front01">Copyright</a></p>
<p class="toc sub"><a href="#/front02">Dedication</a></p>
<p class="toc"><a href="#/c01">The Atonement</a></p>
<p class="toc"><span href="#/c02" title="Link target outside of Sample">Ars Gratia Artis</span></p>
<p class="toc"><span href="#/c03" title="Link target outside of Sample">The Last Great Divorce</span></p>
<p class="toc"><span href="#/c04" title="Link target outside of Sample">The Maenads</span></p>
<p class="toc"><span href="#/c05" title="Link target outside of Sample">The Foursome</span></p>
<p class="toc"><span href="#/c06" title="Link target outside of Sample">Lear’s Shadow</span></p>
<p class="toc"><span href="#/c07" title="Link target outside of Sample">The Hidden Muse</span></p>
<p class="toc"><span href="#/c08" title="Link target outside of Sample">Realist in Babylon</span></p>
<p class="toc"><span href="#/c09" title="Link target outside of Sample">The Golden Voice</span></p>
<p class="toc"><span href="#/c10" title="Link target outside of Sample">Honoria and Attila</span></p>
<p class="toc"><span href="#/c11" title="Link target outside of Sample">The Ancient Greeks</span></p>
<p class="toc"><span href="#/c12" title="Link target outside of Sample">Geraldine: A Spiritual Biography</span></p>
<p class="toc sub"><span href="#/back01" title="Link target outside of Sample">About the Author</span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4f497bc2